import React from "react";
import { string, number } from "prop-types";

const HelpButton = ({link, maxWidth}) => {
  return (
    <div className="help-button-container">
      <span className="help-button-text">Des questions ?</span>
      <a
        className="btn help-button-link"
        href={link}
        style={{ ...(!!maxWidth && { maxWidth })}}
      >
        Contactez-nous
      </a>
    </div>
  )
}

HelpButton.propTypes = {
  link: string,
  maxWidth: number
}

export default HelpButton;
